// src/data/levels.js

export const levels = [
  {
    id: 1,
    title: "Temel Zamirler",
    description: "Ben, sen, o gibi zamirler",
    emoji: "👤",
    questions: [
      { type: "en-tr", question: "I", options: ["Ben", "Sen", "O", "Biz"], correct: 0 },
      { type: "tr-en", question: "Sen", options: ["I", "You", "He", "We"], correct: 1 },
      { type: "en-tr", question: "He", options: ["O (kadın)", "O (erkek)", "Onlar", "Biz"], correct: 1 },
      { type: "tr-en", question: "O (kadın)", options: ["He", "She", "It", "They"], correct: 1 },
      { type: "en-tr", question: "We", options: ["Sen", "O", "Biz", "Onlar"], correct: 2 },
      { type: "tr-en", question: "Onlar", options: ["We", "You", "They", "It"], correct: 2 },
      { type: "en-tr", question: "My", options: ["Senin", "Benim", "Onun", "Bizim"], correct: 1 },
      { type: "tr-en", question: "Bizim", options: ["My", "Your", "Our", "Their"], correct: 2 },
      { type: "en-tr", question: "Your", options: ["Benim", "Senin", "Onun", "Bizim"], correct: 1 },
      { type: "tr-en", question: "Onun", options: ["My", "Your", "His", "Our"], correct: 2 }
    ]
  },
  {
    id: 2,
    title: "Temel Fiiller",
    description: "Olmak, yapmak, gitmek",
    emoji: "🏃",
    questions: [
      { type: "en-tr", question: "be", options: ["yapmak", "olmak", "gitmek", "almak"], correct: 1 },
      { type: "tr-en", question: "yapmak", options: ["be", "have", "do", "go"], correct: 2 },
      { type: "en-tr", question: "go", options: ["gelmek", "gitmek", "görmek", "bilmek"], correct: 1 },
      { type: "tr-en", question: "gelmek", options: ["go", "come", "see", "know"], correct: 1 },
      { type: "en-tr", question: "have", options: ["olmak", "sahip olmak", "yapmak", "gitmek"], correct: 1 },
      { type: "tr-en", question: "almak", options: ["give", "get", "make", "take"], correct: 3 },
      { type: "en-tr", question: "make", options: ["almak", "yapmak", "bilmek", "düşünmek"], correct: 1 },
      { type: "tr-en", question: "vermek", options: ["take", "give", "get", "make"], correct: 1 },
      { type: "en-tr", question: "see", options: ["duymak", "görmek", "hissetmek", "koklamak"], correct: 1 },
      { type: "tr-en", question: "bilmek", options: ["see", "know", "think", "feel"], correct: 1 }
    ]
  },
  {
    id: 3,
    title: "Aile Üyeleri",
    description: "Anne, baba, kardeş",
    emoji: "👨‍👩‍👧‍👦",
    questions: [
      { type: "en-tr", question: "mother", options: ["anne", "baba", "kardeş", "çocuk"], correct: 0 },
      { type: "tr-en", question: "baba", options: ["mother", "father", "brother", "sister"], correct: 1 },
      { type: "en-tr", question: "brother", options: ["kardeş (kız)", "kardeş (erkek)", "anne", "baba"], correct: 1 },
      { type: "tr-en", question: "kız kardeş", options: ["brother", "sister", "mother", "daughter"], correct: 1 },
      { type: "en-tr", question: "family", options: ["ev", "aile", "arkadaş", "komşu"], correct: 1 },
      { type: "tr-en", question: "çocuk", options: ["baby", "child", "parent", "adult"], correct: 1 },
      { type: "en-tr", question: "son", options: ["kız", "oğul", "anne", "baba"], correct: 1 },
      { type: "tr-en", question: "kız (çocuk)", options: ["boy", "daughter", "son", "child"], correct: 1 },
      { type: "en-tr", question: "parent", options: ["çocuk", "ebeveyn", "kardeş", "arkadaş"], correct: 1 },
      { type: "tr-en", question: "büyükanne", options: ["mother", "grandmother", "aunt", "sister"], correct: 1 }
    ]
  },
  {
    id: 4,
    title: "Renkler",
    description: "Kırmızı, mavi, yeşil",
    emoji: "🌈",
    questions: [
      { type: "en-tr", question: "red", options: ["kırmızı", "mavi", "yeşil", "sarı"], correct: 0 },
      { type: "tr-en", question: "mavi", options: ["red", "blue", "green", "yellow"], correct: 1 },
      { type: "en-tr", question: "green", options: ["sarı", "yeşil", "mor", "turuncu"], correct: 1 },
      { type: "tr-en", question: "sarı", options: ["green", "yellow", "orange", "purple"], correct: 1 },
      { type: "en-tr", question: "black", options: ["beyaz", "siyah", "gri", "kahverengi"], correct: 1 },
      { type: "tr-en", question: "beyaz", options: ["black", "white", "gray", "brown"], correct: 1 },
      { type: "en-tr", question: "purple", options: ["pembe", "mor", "turuncu", "gri"], correct: 1 },
      { type: "tr-en", question: "pembe", options: ["purple", "pink", "orange", "gray"], correct: 1 },
      { type: "en-tr", question: "orange", options: ["mor", "turuncu", "pembe", "gri"], correct: 1 },
      { type: "tr-en", question: "kahverengi", options: ["gray", "brown", "black", "white"], correct: 1 }
    ]
  },
  {
    id: 5,
    title: "Sayılar (1-10)",
    description: "Bir, iki, üç...",
    emoji: "🔢",
    questions: [
      { type: "en-tr", question: "one", options: ["bir", "iki", "üç", "dört"], correct: 0 },
      { type: "tr-en", question: "iki", options: ["one", "two", "three", "four"], correct: 1 },
      { type: "en-tr", question: "three", options: ["iki", "üç", "dört", "beş"], correct: 1 },
      { type: "tr-en", question: "dört", options: ["three", "four", "five", "six"], correct: 1 },
      { type: "en-tr", question: "five", options: ["dört", "beş", "altı", "yedi"], correct: 1 },
      { type: "tr-en", question: "altı", options: ["five", "six", "seven", "eight"], correct: 1 },
      { type: "en-tr", question: "seven", options: ["altı", "yedi", "sekiz", "dokuz"], correct: 1 },
      { type: "tr-en", question: "sekiz", options: ["seven", "eight", "nine", "ten"], correct: 1 },
      { type: "en-tr", question: "nine", options: ["yedi", "dokuz", "on", "sekiz"], correct: 1 },
      { type: "tr-en", question: "on", options: ["nine", "ten", "eleven", "twelve"], correct: 1 }
    ]
  },
  {
    id: 6,
    title: "Vücut Parçaları",
    description: "Baş, el, ayak",
    emoji: "🫱",
    questions: [
      { type: "en-tr", question: "head", options: ["baş", "el", "ayak", "göz"], correct: 0 },
      { type: "tr-en", question: "el", options: ["head", "hand", "foot", "eye"], correct: 1 },
      { type: "en-tr", question: "foot", options: ["el", "ayak", "baş", "burun"], correct: 1 },
      { type: "tr-en", question: "göz", options: ["ear", "eye", "nose", "mouth"], correct: 1 },
      { type: "en-tr", question: "ear", options: ["göz", "kulak", "burun", "ağız"], correct: 1 },
      { type: "tr-en", question: "burun", options: ["ear", "nose", "mouth", "eye"], correct: 1 },
      { type: "en-tr", question: "mouth", options: ["burun", "ağız", "kulak", "göz"], correct: 1 },
      { type: "tr-en", question: "saç", options: ["hair", "face", "neck", "arm"], correct: 0 },
      { type: "en-tr", question: "arm", options: ["bacak", "kol", "boyun", "yüz"], correct: 1 },
      { type: "tr-en", question: "bacak", options: ["arm", "leg", "hand", "foot"], correct: 1 }
    ]
  },
  {
    id: 7,
    title: "Yiyecekler",
    description: "Ekmek, su, meyve",
    emoji: "🍎",
    questions: [
      { type: "en-tr", question: "bread", options: ["ekmek", "su", "süt", "et"], correct: 0 },
      { type: "tr-en", question: "su", options: ["bread", "water", "milk", "meat"], correct: 1 },
      { type: "en-tr", question: "apple", options: ["muz", "elma", "portakal", "üzüm"], correct: 1 },
      { type: "tr-en", question: "muz", options: ["apple", "banana", "orange", "grape"], correct: 1 },
      { type: "en-tr", question: "milk", options: ["su", "süt", "çay", "kahve"], correct: 1 },
      { type: "tr-en", question: "et", options: ["fish", "meat", "bread", "rice"], correct: 1 },
      { type: "en-tr", question: "fish", options: ["et", "balık", "tavuk", "yumurta"], correct: 1 },
      { type: "tr-en", question: "peynir", options: ["bread", "cheese", "butter", "milk"], correct: 1 },
      { type: "en-tr", question: "rice", options: ["makarna", "pirinç", "ekmek", "patates"], correct: 1 },
      { type: "tr-en", question: "çay", options: ["coffee", "tea", "water", "milk"], correct: 1 }
    ]
  },
  {
    id: 8,
    title: "Ev Eşyaları",
    description: "Masa, sandalye, yatak",
    emoji: "🏠",
    questions: [
      { type: "en-tr", question: "table", options: ["masa", "sandalye", "yatak", "dolap"], correct: 0 },
      { type: "tr-en", question: "sandalye", options: ["table", "chair", "bed", "door"], correct: 1 },
      { type: "en-tr", question: "bed", options: ["masa", "yatak", "dolap", "pencere"], correct: 1 },
      { type: "tr-en", question: "kapı", options: ["window", "door", "wall", "floor"], correct: 1 },
      { type: "en-tr", question: "window", options: ["kapı", "pencere", "duvar", "tavan"], correct: 1 },
      { type: "tr-en", question: "dolap", options: ["bed", "closet", "table", "chair"], correct: 1 },
      { type: "en-tr", question: "lamp", options: ["saat", "lamba", "ayna", "resim"], correct: 1 },
      { type: "tr-en", question: "halı", options: ["lamp", "carpet", "curtain", "pillow"], correct: 1 },
      { type: "en-tr", question: "mirror", options: ["lamba", "ayna", "saat", "resim"], correct: 1 },
      { type: "tr-en", question: "yastık", options: ["blanket", "pillow", "sheet", "carpet"], correct: 1 }
    ]
  },
  {
    id: 9,
    title: "Hayvanlar",
    description: "Kedi, köpek, kuş",
    emoji: "🐱",
    questions: [
      { type: "en-tr", question: "cat", options: ["kedi", "köpek", "kuş", "balık"], correct: 0 },
      { type: "tr-en", question: "köpek", options: ["cat", "dog", "bird", "fish"], correct: 1 },
      { type: "en-tr", question: "bird", options: ["balık", "kuş", "fare", "kedi"], correct: 1 },
      { type: "tr-en", question: "balık", options: ["bird", "fish", "mouse", "horse"], correct: 1 },
      { type: "en-tr", question: "horse", options: ["inek", "at", "koyun", "domuz"], correct: 1 },
      { type: "tr-en", question: "inek", options: ["horse", "cow", "sheep", "pig"], correct: 1 },
      { type: "en-tr", question: "lion", options: ["kaplan", "aslan", "ayı", "kurt"], correct: 1 },
      { type: "tr-en", question: "fil", options: ["lion", "elephant", "tiger", "bear"], correct: 1 },
      { type: "en-tr", question: "monkey", options: ["aslan", "maymun", "zebra", "zürafa"], correct: 1 },
      { type: "tr-en", question: "tavşan", options: ["mouse", "rabbit", "hamster", "guinea pig"], correct: 1 }
    ]
  },
  {
    id: 10,
    title: "Kıyafetler",
    description: "Gömlek, pantolon, ayakkabı",
    emoji: "👕",
    questions: [
      { type: "en-tr", question: "shirt", options: ["gömlek", "pantolon", "ayakkabı", "şapka"], correct: 0 },
      { type: "tr-en", question: "pantolon", options: ["shirt", "pants", "shoes", "hat"], correct: 1 },
      { type: "en-tr", question: "shoes", options: ["çorap", "ayakkabı", "eldiven", "kemer"], correct: 1 },
      { type: "tr-en", question: "şapka", options: ["shoes", "hat", "gloves", "belt"], correct: 1 },
      { type: "en-tr", question: "dress", options: ["etek", "elbise", "bluz", "ceket"], correct: 1 },
      { type: "tr-en", question: "ceket", options: ["dress", "jacket", "skirt", "blouse"], correct: 1 },
      { type: "en-tr", question: "socks", options: ["ayakkabı", "çorap", "eldiven", "eşarp"], correct: 1 },
      { type: "tr-en", question: "etek", options: ["pants", "skirt", "dress", "shirt"], correct: 1 },
      { type: "en-tr", question: "coat", options: ["palto", "mont", "hırka", "yelek"], correct: 0 },
      { type: "tr-en", question: "eldiven", options: ["socks", "gloves", "mittens", "scarf"], correct: 1 }
    ]
  },
  {
    id: 11,
    title: "Hava Durumu",
    description: "Güneşli, yağmurlu, kar",
    emoji: "🌤️",
    questions: [
      { type: "en-tr", question: "sunny", options: ["güneşli", "yağmurlu", "karlı", "rüzgarlı"], correct: 0 },
      { type: "tr-en", question: "yağmurlu", options: ["sunny", "rainy", "snowy", "windy"], correct: 1 },
      { type: "en-tr", question: "cold", options: ["sıcak", "soğuk", "ılık", "serin"], correct: 1 },
      { type: "tr-en", question: "sıcak", options: ["cold", "hot", "warm", "cool"], correct: 1 },
      { type: "en-tr", question: "snow", options: ["yağmur", "kar", "rüzgar", "güneş"], correct: 1 },
      { type: "tr-en", question: "rüzgar", options: ["rain", "wind", "snow", "sun"], correct: 1 },
      { type: "en-tr", question: "cloudy", options: ["açık", "bulutlu", "sisli", "karlı"], correct: 1 },
      { type: "tr-en", question: "fırtına", options: ["calm", "storm", "breeze", "drizzle"], correct: 1 },
      { type: "en-tr", question: "hot", options: ["soğuk", "sıcak", "ılık", "serin"], correct: 1 },
      { type: "tr-en", question: "sis", options: ["cloud", "fog", "mist", "haze"], correct: 1 }
    ]
  },
  {
    id: 12,
    title: "Zaman",
    description: "Bugün, yarın, saat",
    emoji: "⏰",
    questions: [
      { type: "en-tr", question: "today", options: ["bugün", "yarın", "dün", "şimdi"], correct: 0 },
      { type: "tr-en", question: "yarın", options: ["today", "tomorrow", "yesterday", "now"], correct: 1 },
      { type: "en-tr", question: "yesterday", options: ["bugün", "dün", "yarın", "sonra"], correct: 1 },
      { type: "tr-en", question: "şimdi", options: ["then", "now", "later", "before"], correct: 1 },
      { type: "en-tr", question: "morning", options: ["öğle", "sabah", "akşam", "gece"], correct: 1 },
      { type: "tr-en", question: "akşam", options: ["morning", "evening", "afternoon", "night"], correct: 1 },
      { type: "en-tr", question: "week", options: ["gün", "hafta", "ay", "yıl"], correct: 1 },
      { type: "tr-en", question: "ay", options: ["day", "month", "year", "week"], correct: 1 },
      { type: "en-tr", question: "hour", options: ["dakika", "saat", "saniye", "zaman"], correct: 1 },
      { type: "tr-en", question: "dakika", options: ["hour", "minute", "second", "time"], correct: 1 }
    ]
  },
  {
    id: 13,
    title: "Duygular",
    description: "Mutlu, üzgün, kızgın",
    emoji: "😊",
    questions: [
      { type: "en-tr", question: "happy", options: ["mutlu", "üzgün", "kızgın", "yorgun"], correct: 0 },
      { type: "tr-en", question: "üzgün", options: ["happy", "sad", "angry", "tired"], correct: 1 },
      { type: "en-tr", question: "angry", options: ["mutlu", "kızgın", "korkunç", "şaşkın"], correct: 1 },
      { type: "tr-en", question: "yorgun", options: ["excited", "tired", "energetic", "sleepy"], correct: 1 },
      { type: "en-tr", question: "excited", options: ["sıkılmış", "heyecanlı", "sakin", "endişeli"], correct: 1 },
      { type: "tr-en", question: "korkmuş", options: ["brave", "scared", "confident", "calm"], correct: 1 },
      { type: "en-tr", question: "surprised", options: ["beklenen", "şaşkın", "normal", "sıradan"], correct: 1 },
      { type: "tr-en", question: "gurur", options: ["shame", "pride", "guilt", "regret"], correct: 1 },
      { type: "en-tr", question: "calm", options: ["gergin", "sakin", "heyecanlı", "endişeli"], correct: 1 },
      { type: "tr-en", question: "endişeli", options: ["calm", "worried", "relaxed", "peaceful"], correct: 1 }
    ]
  },
  {
    id: 14,
    title: "Meslek",
    description: "Doktor, öğretmen, mühendis",
    emoji: "👨‍⚕️",
    questions: [
      { type: "en-tr", question: "doctor", options: ["doktor", "öğretmen", "mühendis", "avukat"], correct: 0 },
      { type: "tr-en", question: "öğretmen", options: ["doctor", "teacher", "engineer", "lawyer"], correct: 1 },
      { type: "en-tr", question: "nurse", options: ["doktor", "hemşire", "ebe", "teknisyen"], correct: 1 },
      { type: "tr-en", question: "polis", options: ["nurse", "police", "firefighter", "soldier"], correct: 1 },
      { type: "en-tr", question: "chef", options: ["garson", "aşçı", "barista", "temizlik"], correct: 1 },
      { type: "tr-en", question: "mühendis", options: ["architect", "engineer", "designer", "builder"], correct: 1 },
      { type: "en-tr", question: "pilot", options: ["kaptan", "pilot", "makinist", "şoför"], correct: 1 },
      { type: "tr-en", question: "avukat", options: ["judge", "lawyer", "prosecutor", "attorney"], correct: 1 },
      { type: "en-tr", question: "artist", options: ["müzisyen", "sanatçı", "yazar", "şarkıcı"], correct: 1 },
      { type: "tr-en", question: "çiftçi", options: ["gardener", "farmer", "rancher", "botanist"], correct: 1 }
    ]
  },
  {
    id: 15,
    title: "Spor",
    description: "Futbol, basketbol, tenis",
    emoji: "⚽",
    questions: [
      { type: "en-tr", question: "football", options: ["futbol", "basketbol", "voleybol", "tenis"], correct: 0 },
      { type: "tr-en", question: "basketbol", options: ["football", "basketball", "volleyball", "tennis"], correct: 1 },
      { type: "en-tr", question: "tennis", options: ["badminton", "tenis", "ping pong", "squash"], correct: 1 },
      { type: "tr-en", question: "yüzme", options: ["running", "swimming", "cycling", "walking"], correct: 1 },
      { type: "en-tr", question: "running", options: ["yürüme", "koşu", "zıplama", "sıçrama"], correct: 1 },
      { type: "tr-en", question: "bisiklet", options: ["car", "bicycle", "motorcycle", "scooter"], correct: 1 },
      { type: "en-tr", question: "boxing", options: ["güreş", "boks", "karate", "judo"], correct: 1 },
      { type: "tr-en", question: "golf", options: ["tennis", "golf", "hockey", "cricket"], correct: 1 },
      { type: "en-tr", question: "dancing", options: ["şarkı", "dans", "müzik", "sahne"], correct: 1 },
      { type: "tr-en", question: "yoga", options: ["pilates", "yoga", "aerobic", "fitness"], correct: 1 }
    ]
  },
  {
    id: 16,
    title: "Ulaşım",
    description: "Araba, otobüs, uçak",
    emoji: "🚗",
    questions: [
      { type: "en-tr", question: "car", options: ["araba", "otobüs", "kamyon", "motor"], correct: 0 },
      { type: "tr-en", question: "otobüs", options: ["car", "bus", "truck", "van"], correct: 1 },
      { type: "en-tr", question: "plane", options: ["gemi", "uçak", "helikopter", "roket"], correct: 1 },
      { type: "tr-en", question: "tren", options: ["bus", "train", "subway", "tram"], correct: 1 },
      { type: "en-tr", question: "ship", options: ["tekne", "gemi", "yat", "sal"], correct: 1 },
      { type: "tr-en", question: "bisiklet", options: ["motorcycle", "bicycle", "scooter", "skateboard"], correct: 1 },
      { type: "en-tr", question: "taxi", options: ["taksi", "dolmuş", "minibüs", "servis"], correct: 0 },
      { type: "tr-en", question: "metro", options: ["bus", "subway", "tram", "train"], correct: 1 },
      { type: "en-tr", question: "helicopter", options: ["uçak", "helikopter", "jet", "roket"], correct: 1 },
      { type: "tr-en", question: "motosiklet", options: ["bicycle", "motorcycle", "scooter", "moped"], correct: 1 }
    ]
  },
  {
    id: 17,
    title: "Teknologi",
    description: "Bilgisayar, telefon, internet",
    emoji: "💻",
    questions: [
      { type: "en-tr", question: "computer", options: ["bilgisayar", "telefon", "tablet", "televizyon"], correct: 0 },
      { type: "tr-en", question: "telefon", options: ["computer", "phone", "tablet", "camera"], correct: 1 },
      { type: "en-tr", question: "internet", options: ["televizyon", "internet", "radyo", "gazete"], correct: 1 },
      { type: "tr-en", question: "klavye", options: ["mouse", "keyboard", "screen", "speaker"], correct: 1 },
      { type: "en-tr", question: "camera", options: ["fotoğraf", "kamera", "video", "film"], correct: 1 },
      { type: "tr-en", question: "ekran", options: ["keyboard", "screen", "mouse", "printer"], correct: 1 },
      { type: "en-tr", question: "email", options: ["mektup", "e-posta", "mesaj", "not"], correct: 1 },
      { type: "tr-en", question: "yazılım", options: ["hardware", "software", "program", "application"], correct: 1 },
      { type: "en-tr", question: "website", options: ["sayfa", "web sitesi", "blog", "forum"], correct: 1 },
      { type: "tr-en", question: "şifre", options: ["username", "password", "login", "account"], correct: 1 }
    ]
  },
  {
    id: 18,
    title: "Okul",
    description: "Ders, öğrenci, kitap",
    emoji: "🎓",
    questions: [
      { type: "en-tr", question: "school", options: ["okul", "sınıf", "ders", "öğretmen"], correct: 0 },
      { type: "tr-en", question: "öğrenci", options: ["teacher", "student", "principal", "professor"], correct: 1 },
      { type: "en-tr", question: "book", options: ["defter", "kitap", "kalem", "silgi"], correct: 1 },
      { type: "tr-en", question: "ders", options: ["homework", "lesson", "exam", "grade"], correct: 1 },
      { type: "en-tr", question: "homework", options: ["ders", "ödev", "sınav", "not"], correct: 1 },
      { type: "tr-en", question: "sınav", options: ["homework", "exam", "quiz", "test"], correct: 1 },
      { type: "en-tr", question: "pen", options: ["kalem", "silgi", "cetvel", "defter"], correct: 0 },
      { type: "tr-en", question: "defter", options: ["book", "notebook", "paper", "folder"], correct: 1 },
      { type: "en-tr", question: "library", options: ["sınıf", "kütüphane", "laboratuvar", "kantin"], correct: 1 },
      { type: "tr-en", question: "diploma", options: ["certificate", "diploma", "degree", "award"], correct: 1 }
    ]
  },
  {
    id: 19,
    title: "Doğa",
    description: "Ağaç, çiçek, deniz",
    emoji: "🌳",
    questions: [
      { type: "en-tr", question: "tree", options: ["ağaç", "çiçek", "ot", "yaprak"], correct: 0 },
      { type: "tr-en", question: "çiçek", options: ["tree", "flower", "grass", "leaf"], correct: 1 },
      { type: "en-tr", question: "sea", options: ["göl", "deniz", "nehir", "okyanus"], correct: 1 },
      { type: "tr-en", question: "dağ", options: ["hill", "mountain", "valley", "plain"], correct: 1 },
      { type: "en-tr", question: "forest", options: ["çöl", "orman", "tarla", "bahçe"], correct: 1 },
      { type: "tr-en", question: "güneş", options: ["moon", "sun", "star", "planet"], correct: 1 },
      { type: "en-tr", question: "river", options: ["deniz", "nehir", "göl", "dere"], correct: 1 },
      { type: "tr-en", question: "yıldız", options: ["sun", "star", "moon", "planet"], correct: 1 },
      { type: "en-tr", question: "beach", options: ["orman", "plaj", "çöl", "dağ"], correct: 1 },
      { type: "tr-en", question: "kaya", options: ["sand", "rock", "stone", "pebble"], correct: 1 }
    ]
  },
  {
    id: 20,
    title: "Karma Kelimeler",
    description: "Çeşitli kategorilerden",
    emoji: "🎯",
    questions: [
      { type: "en-tr", question: "beautiful", options: ["güzel", "çirkin", "büyük", "küçük"], correct: 0 },
      { type: "tr-en", question: "hızlı", options: ["slow", "fast", "big", "small"], correct: 1 },
      { type: "en-tr", question: "expensive", options: ["ucuz", "pahalı", "bedava", "indirimli"], correct: 1 },
      { type: "tr-en", question: "kolay", options: ["hard", "easy", "difficult", "complex"], correct: 1 },
      { type: "en-tr", question: "strong", options: ["zayıf", "güçlü", "hasta", "sağlıklı"], correct: 1 },
      { type: "tr-en", question: "temiz", options: ["dirty", "clean", "messy", "tidy"], correct: 1 },
      { type: "en-tr", question: "important", options: ["önemsiz", "önemli", "gereksiz", "faydasız"], correct: 1 },
      { type: "tr-en", question: "sessiz", options: ["loud", "quiet", "noisy", "silent"], correct: 1 },
      { type: "en-tr", question: "famous", options: ["bilinmeyen", "ünlü", "gizli", "saklı"], correct: 1 },
      { type: "tr-en", question: "başarılı", options: ["failed", "successful", "losing", "defeated"], correct: 1 }
    ]
  }
];

// Bölüm kilitleme sistemi için yardımcı fonksiyonlar
export const isLevelUnlocked = (levelId, completedLevels) => {
  if (levelId === 1) return true; // İlk bölüm her zaman açık
  return completedLevels.includes(levelId - 1); // Önceki bölüm tamamlanmışsa açık
};

export const getLevelProgress = (levelId, userProgress) => {
  const progress = userProgress[levelId] || { completed: false, score: 0, attempts: 0 };
  return progress;
};